import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 25,
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#F25022",
			d: "M11.428 1.643H1.143V11.93h10.285V1.643Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#00A4EF",
			d: "M11.428 13.071H1.143v10.286h10.285V13.071Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#7FBA00",
			d: "M22.857 1.643H12.572V11.93h10.285V1.643Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFB900",
			d: "M22.857 13.071H12.572v10.286h10.285V13.071Z"
		})
	]
});
export default SvgMsIcon;
